/* tslint:disable:object-shorthand-properties-first */
import Fetch from '@App/helpers/fetch'
import awaitToJs, { to } from 'await-to-js'
import { setAlertBox } from '../../actions/snackbar'
import * as cookie from 'js-cookie'

import {
  SET_USERS_LIST,
  ALERT_COLORS,
  MESSAGE_ERROR,
  SET_USER_BY_ID,
  ALERT_DELAY,
  COOKIES_AUTHORIZATION_TOKEN,
  COOKIE_DOMAIN,
  MESSAGE_SUCCESS,
  COOKIES_BLIINK_USERS,
} from '@App/constantes'
import { UserIncludes, Constants, ICreateOrUpdateUser } from '@App/store/user/types'
import { API_URL }                   from '@App/configs/rest'
import { logoutUser, setSignInUser } from '@App/actions'
import { store }                     from '@App/helpers/configureStore'

const COOKIE_EXP = 3600 * 3

const fetchUsersList = new Fetch()
const fetchCreateUser = new Fetch()
const fetchLoginUserWith2FA = new Fetch()
const fetchDisableLoginWith2FA = new Fetch()
const fetchDisableLoginWith2FAConfirm = new Fetch()
const fetchUserById = new Fetch()
const fetchGetDeleteUserById = new Fetch()

export function setCurrentUser(user: any | null) {
  return {
    type: Constants.SET_CURRENT,
    payload: user,
  }
}

export const setResetUserForm = (value?: boolean) => {
  return {
    type: Constants.RESET_USER,
    payload: value,
  }
}

export const setUsersList = (users: {}) => {
  return {
    type: SET_USERS_LIST,
    payload: users,
  }
}

export const setUserById = (users: {}) => {
  return {
    type: SET_USER_BY_ID,
    payload: users,
  }
}

export const loginWith2FA = (body: any) => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(
      fetchLoginUserWith2FA.post({
        body,
        url: `${API_URL}/users/auth/two-factor/login`,
        headers: {
          'content-type': 'application/json',
        },
      }),
    )

    if (!err && data) {
      cookie.set(COOKIES_AUTHORIZATION_TOKEN, data.token, { expires: COOKIE_EXP, domain: COOKIE_DOMAIN })
      window.localStorage.setItem(COOKIES_BLIINK_USERS, JSON.stringify(data.user))

      dispatch(setSignInUser(Object.assign({}, data.user)))

      return data
    }

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
  }
}

export const disable2FA = () => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(
      fetchDisableLoginWith2FA.post({
        body: {},
        url: `${API_URL}/users/auth/two-factor/disable`,
        headers: {
          'content-type': 'application/json',
        },
      }),
    )

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }

    return data
  }
}

export const disable2FAConfirm = (body: any) => {
  return async (dispatch: any, getState: any) => {
    const [err, data]: any = await awaitToJs(
      fetchDisableLoginWith2FAConfirm.post({
        body,
        url: `${API_URL}/users/auth/two-factor/disable-confirm`,
        headers: {
          'content-type': 'application/json',
        },
      }),
    )

    if (!err && data) {
      dispatch(
        setAlertBox({
          title: data?.message || MESSAGE_ERROR,
          background: ALERT_COLORS.green,
          delay: ALERT_DELAY,
        }),
      )

      dispatch(getUserById(getState().user.user.id))

      return data
    }

    if (!data && err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }

    return null
  }
}

export const createUser = (body: ICreateOrUpdateUser) => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(
      fetchCreateUser.post({
        url: `${API_URL}/users`,
        body,
        headers: {
          'content-type': 'application/json',
        },
      }),
    )

    if (err instanceof Error) {
      dispatch(
        setAlertBox({
          title: err?.message || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }

    if (!err && data) {
      dispatch(getUsersList())

      dispatch(
        setAlertBox({
          title: 'Utilisateur créer avec succès',
          background: ALERT_COLORS.green,
          delay: ALERT_DELAY,
        }),
      )

      return data
    }
  }
}

export const updateUser = (body: ICreateOrUpdateUser, id: number) => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(
      fetchCreateUser.put({
        url: `${API_URL}/users/${id}`,
        body,
        headers: {},
      }),
    )

    if (!err && data) {
      dispatch(getUsersList())

      dispatch(
        setAlertBox({
          title: "Mise à jour de l'utilisateur avec succès",
          background: ALERT_COLORS.green,
          delay: ALERT_DELAY,
        }),
      )

      return data
    }

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
  }
}

export const getUsersList = (search?: string) => {
  return async (dispatch: any, _: any) => {
    const [err, data] = await awaitToJs(
      fetchUsersList.get({
        url: `${API_URL}/users`,
        headers: {},
        params: {
          include: [
            UserIncludes.ORGANIZATION,
            UserIncludes.NETWORKS,
            UserIncludes.SEGMENTS,
            UserIncludes.JOB,
            UserIncludes.ROLE,
          ],
          search: search || undefined,
        },
      }),
    )

    if (!err && data) {
      dispatch(setUsersList(data))

      return data
    }

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
  }
}

export const getUserById = (id: string) => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(
      fetchUserById.get({
        url: `${API_URL}/users/${id}`,
        headers: {},
        params: {},
      }),
    )

    if (!err && data) {
      dispatch(setSignInUser(data))

      return data
    }

    if (!err && data) {
      return err
    }
  }
}

export const deleteUser = (id: Number) => {
  return async (dispatch: any) => {
    const [err] = await awaitToJs(
      fetchGetDeleteUserById.delete({
        url: `${API_URL}/users/${id}`,
        params: null,
        body: {},
      }),
    )

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }

    dispatch(
      setAlertBox({
        title: MESSAGE_SUCCESS,
        background: ALERT_COLORS.green,
        delay: ALERT_DELAY,
      }),
    )

    return
  }
}

export const fetchUser = async () => {
  const userItem: string = localStorage.getItem('user') || ''
  if (userItem) {
    try {
      const user = JSON.parse(userItem)
      if (user?.id) {
        const [, data] = await to(store.dispatch(getUserById(user.id)))
        if (data) return
      }
    } catch (error) {
      console.error('Error parsing user data or fetching user by ID:', error)
    }
  }
  logoutUser()
}
